(function() { window.GUID_c215a310_644b_4a7b_a6e0_76c68a829c5a = { getGuid: function() { return "c215a310-644b-4a7b-a6e0-76c68a829c5a"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TimePicker extends Controls.ControlValueBase {
            constructor(id) {
                super(id);
            }
            OnBindEvents() {
                let me = this;
                CS.Controls.DropDownPicker.Events.ValueChange(Controls.DropDownPicker, {
                    selector: me.$Control,
                    childSelector: ".dropdown-picker",
                    callback: (control, e) => {
                        me.pushDropDownValuesToHidden();
                    }
                });
            }
            pushDropDownValuesToHidden() {
                let $hour = this.$divContainer.find("#dropdown-" + this.ControlId + "-dropdownpicker-hour-hidden");
                let $minute = this.$divContainer.find("#dropdown-" + this.ControlId + "-dropdownpicker-minute-hidden");
                let $amPm = this.$divContainer.find("#dropdown-" + this.ControlId + "-dropdownpicker-ampm-hidden");
                this.$hidden.val($hour.val() + ":" + $minute.val() + ":00" + " " + $amPm.val());
            }
            OnDispose() {
            }
            get ControlId() {
                return this.$divContainer.attr('id');
            }
            get $Control() {
                return this.$divContainer;
            }
            OnControlInstantiation(params) {
                this.$divContainer = $(params[0]); //contient le Id
                this.$hidden = this.$divContainer.find("#" + this.ControlId + "-hidden");
            }
        }
        Controls.TimePicker = TimePicker;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=timepicker.js.map
